if (!process.env.VUE_APP_IS_WEB) {
  var MeetingDB = require("../database/models/Meeting");

  var complexDBFunctions = require("../database/complex-functions").default;
}
import useAlerts from "@/use/useAlerts.js";

import strings from "@/database/strings";

import MeetingORM from "@/store/orm-axios/models/Meeting";

export default {
  GET_WITH_RELATED_MEDIA(meeting_id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MeetingDB()
          .query({
            where: {
              id: meeting_id,
              deleted: null,
            },
          })
          .fetch({
            withRelated: [
              {
                building: query => {
                  query.where("deleted", null);
                },
              },
              "agenda_pdf",
              {
                meeting_resolutions: query => {
                  query.where("deleted", null);
                  query.where("parent_resolution_id", null);
                },
              },
              {
                mandates: query => {
                  query.where("deleted", null);
                },
              },
              "mandates.invitation_pdf",
              "mandates.pouvoir_pdf",
              "mandates.voting_form_pdf",
              "mandates.merged_pdf",
              {
                "mandates.building_owner": query => {
                  query.where("deleted", null);
                },
              },
            ],
          })
          .then(res => {
            console.log("RES GET MEDIA", res.serialize());
            var data = res.serialize();

            MeetingORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .GET_WITH_RELATED_MEDIA(meeting_id)
          .then(res => {
            // console.log("GET_WITH_RELATED_MEDIA: res", res.response.data);
            resolve(res.response.data);
          })
          .catch(err => {
            console.error("GET_WITH_RELATED_MEDIA: err", err);
            reject(err);
          });
      });
    }
  },
  FETCH_BY_PAGE(queryParams, pagination, properties) {
    queryParams.page = pagination.page;
    //! check which parameter is expected by the API
    queryParams.pageSize = pagination.pageSize;
    queryParams.itemsPerPage = pagination.pageSize;
    if (!process.env.VUE_APP_IS_WEB) {
      // ???: might need changes
      var mainTable = "meeting";
      var pivotResolutionTable = "meeting_resolution";
      var relatedBuildingTable = "building";
      return new Promise((resolve, reject) => {
        new MeetingDB()
          .query(qb => {
            qb.where(`${mainTable}.agency_id`, agencyId);
            qb.where(`${mainTable}.deleted`, null);
            // qb.orderBy("created", "desc");
            qb.leftJoin(
              `${pivotResolutionTable}`,
              `${mainTable}.id`,
              `${pivotResolutionTable}.meeting_id`
            );
            qb.where(`${pivotResolutionTable}.parent_resolution_id`, null);
            qb.groupBy(`${mainTable}.id`);
            qb.select(`${mainTable}.*`);
            qb.count("* as resolutions_count");
            // qb.orderBy("resolutions_count", "desc");
            queryParams.filter.forEach(filter => {
              qb.where(`${mainTable}.${filter.column}`, "LIKE", "%" + filter.value + "%");
            });
            qb.orderBy(`${mainTable}.${queryParams.sort.by}`, queryParams.sort.dir);
          })
          .fetchPage({
            pageSize: pagination.pageSize,
            page: pagination.page,
            withRelated: [
              {
                building: query => {
                  query.where("deleted", null);
                },
              },
            ],
          })
          .then(res => {
            var data = res.serialize();
            MeetingORM.insertOrUpdate({
              data: data,
            });
            resolve(res);
          })
          .catch(err => {
            console.error(err);
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .QUERY_FETCH(queryParams, properties)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MeetingDB({ id: id, deleted: null })
          .fetch({
            withRelated: [
              {
                building: query => {
                  query.where("deleted", null);
                },
              },
              // ???: ??
              // {
              //   resolutions: query => {
              //     query.where("resolution.deleted", null);
              //   },
              // },
              {
                mandates: query => {
                  query.where("deleted", null);
                },
              },
            ],
          })
          .then(res => {
            let data = res.serialize();
            MeetingORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET_DOCUMENTS(id) {
    return new Promise(resolve => {
      if (!process.env.VUE_APP_IS_WEB) {
        // TODO: desktop
      } else {
        MeetingORM.api()
          .GET_DOCUMENTS(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            const { alertErrorAndReport } = useAlerts();
            alertErrorAndReport(
              err,
              "La connexion à l'API a été perdue !",
              "Veuillez vérifier votre connexion Internet."
            );
          });
      }
    });
  },
  POST(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));
      itemPost.slug = strings.get_slug(itemPost.name);
      return new Promise((resolve, reject) => {
        new MeetingDB(itemPost)
          .save()
          .then(res => {
            var data = res.serialize();
            MeetingORM.insertOrUpdate({
              data: data,
            });
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item, save = true) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));
      itemPut.slug = strings.get_slug(itemPut.name);

      return new Promise((resolve, reject) => {
        new MeetingDB(itemPut)
          .save(null, { isUpdate: true })
          .then(res => {
            var data = res.serialize();
            if (save) {
              // console.log("saveMeetingInORM");
              MeetingORM.insertOrUpdate({
                data: data,
              });
            }
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise(resolve => {
        MeetingORM.api()
          .PUT(item, save)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            const { alertErrorAndReport } = useAlerts();
            alertErrorAndReport(
              err,
              "La connexion à l'API a été perdue !",
              "Veuillez vérifier votre connexion Internet."
            );
          });
      });
    }
  },
  DELETE(item, doZipBackup) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemDelete = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new MeetingDB(itemDelete)
          .save(null, { isDelete: true })
          .then(res => {
            MeetingORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .DELETE(item, doZipBackup)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },

  SEND_NOTIFICATIONS(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .MEETING_SEND_NOTIFICATIONS(item.id)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },

  CREATE_MANDATES_FOR_MEETING(meeting) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        complexDBFunctions
          .createMandatesForMeeting(meeting)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .CREATE_MANDATES_FOR_MEETING(meeting)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  MEETING_INVITATION_READY_TO_SEND(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      //  TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .MEETING_INVITATION_READY_TO_SEND(meetingId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  MEETING_DUPLICATE(meeting) {
    if (!process.env.VUE_APP_IS_WEB) {
      //  TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .MEETING_DUPLICATE(meeting)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  START(meeting) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .START(meeting)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  RESET(meeting) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .RESET(meeting)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET_BY_BUILDING(buildingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO Need implementation
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .GET_BY_BUILDING(buildingId)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  MEETING_RESOLUTION_STATUS_NOT_VOTED(meeting) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .MEETING_RESOLUTION_STATUS_NOT_VOTED(meeting)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  ARCHIVE(item, userMediaId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .ARCHIVE(item, userMediaId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  REGISTER(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .REGISTER_DETAILS(meetingId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  UPDATE_DOCS_PRINT_COLOR(meeting) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .UPDATE_DOCS_PRINT_COLOR(meeting)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  UPDATE_CURRENT_RESOLUTION(meeting) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .UPDATE_CURRENT_RESOLUTION(meeting)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  UPDATE_MINUTES(meeting) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        MeetingORM.api()
          .UPDATE_MINUTES(meeting)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
